import { render, staticRenderFns } from "./InvalidInvitationKey.vue?vue&type=template&id=3656c994"
import script from "./InvalidInvitationKey.vue?vue&type=script&lang=js"
export * from "./InvalidInvitationKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports